import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import rovoGreetingIcon from './assets/rovo-greeting-icon.svg';

const i18n = defineMessages({
	rovoLogoAltText: {
		id: 'experiment-welcome-from-rovo.greeting.logo.alt-text',
		defaultMessage: 'Rovo logo',
		description: 'Alt text for the Rovo logo shown in the Rovo mini-modal welcome greeting card.',
	},
	greetingTitle: {
		id: 'experiment-welcome-from-rovo.greeting.title',
		defaultMessage: 'Hi, I’m Rovo',
		description: 'Title shown in the Rovo mini-modal welcome greeting card.',
	},
	greetingDescription: {
		id: 'experiment-welcome-from-rovo.greeting.description',
		defaultMessage:
			'I can help you find answers and act on your team’s knowledge. Try the prompt below to see how I work!',
		description: 'Body copy shown in the Rovo mini-modal welcome greeting card.',
	},
	promptPrefill: {
		id: 'experiment-welcome-from-rovo.prompt.prefill',
		defaultMessage: 'Summarize what this space is about',
		description: 'Pre-filled sample prompt shown in the Rovo mini-modal chat input.',
	},
});

export type WelcomeFromRovoChatUiConfig = {
	customGreeting: {
		iconSrc: string;
		title: string;
		subtitle: string;
		titleSize: 'large';
		testId: string;
		imageHeight: number;
	};
	initialPromptText?: string;
	shouldSeedInitialPromptText: boolean;
};

export const useWelcomeFromRovoChatUiConfig = (): WelcomeFromRovoChatUiConfig => {
	const { formatMessage } = useIntl();

	return useMemo(
		() => ({
			customGreeting: {
				iconSrc: rovoGreetingIcon,
				title: formatMessage(i18n.greetingTitle),
				subtitle: formatMessage(i18n.greetingDescription),
				titleSize: 'large',
				testId: 'welcome-from-rovo',
				imageHeight: 48,
			},
			initialPromptText: formatMessage(i18n.promptPrefill),
			shouldSeedInitialPromptText: true,
		}),
		[formatMessage],
	);
};
